import { Pencil } from 'lucide-react';
import { Pill } from '@/shared/components';
import type { PropertyGroupResponse } from '@/shared/api';
import { CardEditButton, AreaCard } from './AreaCard';
import { clockTime } from './objectEditForms';

/**
 * Check-in und Check-out des Objekts — sichtbar bei den übrigen Stammdaten, weil sie genau dort
 * gesucht werden. Die Zeiten gelten für alle Apartments; was mit ihnen rechnet, steht im Fuß.
 */
export function ObjectStayTimesSection({
  group,
  canEdit,
  onEdit,
}: {
  group: PropertyGroupResponse;
  canEdit: boolean;
  onEdit: () => void;
}) {
  return (
    <AreaCard
      title="Check-in & Check-out"
      aside={
        canEdit && (
          <CardEditButton
            label="Check-in und Check-out bearbeiten"
            icon={<Pencil size={14} />}
            onClick={onEdit}
          />
        )
      }
      footer={
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-ink-soft mr-1 text-[11px] font-semibold uppercase tracking-[0.08em]">
            Wirkt auf
          </span>
          {['Reinigungsfenster', 'Gastportal', 'Anfahrt'].map((use) => (
            <Pill key={use}>{use}</Pill>
          ))}
        </div>
      }
    >
      <dl className="grid grid-cols-2">
        <StayTime label="Check-in ab" value={group.checkInTime} />
        <StayTime label="Check-out bis" value={group.checkOutTime} divided />
      </dl>
    </AreaCard>
  );
}

function StayTime({ label, value, divided }: { label: string; value: string; divided?: boolean }) {
  return (
    <div className={divided ? 'border-line/60 border-l pl-5' : undefined}>
      <dt className="text-ink-soft text-[11px] font-semibold uppercase tracking-[0.08em]">
        {label}
      </dt>
      <dd className="text-ink mt-1 font-serif text-[40px] tabular-nums leading-none">
        {clockTime(value) || '—'}
      </dd>
    </div>
  );
}
